<template>
    <SectionViewLayout
      title='settings.out_of_office.title'
      :content_state='content_state'
      content_class="out-of-office"
      close_route="settings"
    >
        <template #actions>
            <ActionButton
                @click='save()'
                v-tooltip='"global.actions.save"'
                icon="fas fa-save"
                :disabled=content_state.saving
                :gtm="{
                    module : 'out_of_office_settings',
                    feature: 'out_of_office_form',
                    block  : `top_actions`,
                    action : 'submit'
                }"
            />
        </template>

        <template #content>
            <form>
                <fieldset>
                    <legend>{{Language.say('settings.out_of_office.labels.define_message')}}</legend>
                    <p>{{Language.say('settings.out_of_office.define_message_text')}}zz</p>
                    <InputRadio
                      input_name="radio"
                      tag_text="settings.out_of_office."
                      v-model:input_value="out_of_office_controller.options.enabled"
                      :options="{'deactivated': false, 'activated' : true}">
                    </InputRadio>
                </fieldset>

                <div v-if="out_of_office_controller.options.enabled === true">
                    <fieldset >
                        <legend>{{Language.say('settings.out_of_office.labels.period')}}</legend>
                        <InputDateRange
                          input_date_start_name="date_start"
                          input_date_end_name="date_end"
                          :input_date_start="out_of_office_controller.options.date_start"
                          :input_date_end="out_of_office_controller.options.date_end"
                          :input_invalids="properties_validation.invalid"
                          @update:input_date_start="value => { out_of_office_controller.options.date_start = value; }"
                          @update:input_date_end="value => { out_of_office_controller.options.date_end = value; }"
                          @change="onChangeDate()">
                        </InputDateRange>
                    </fieldset>

                    <fieldset>
                        <legend>{{Language.say('settings.out_of_office.labels.message_to_send')}}</legend>
                        <InputTextArea
                          v-model:input_value="out_of_office_controller.options.message"
                          input_name="message"
                          input_placeholder="settings.out_of_office.placeholders.message_text_area"
                          :input_invalids="properties_validation.invalid"
                          error_text="settings.out_of_office.invalid.message"
                          @change="validateFields()">
                        </InputTextArea>

                        <ActionButton
                            @click='resetMessage()'
                            text="settings.out_of_office.actions.replace_predefined_message"
                            icon="fas fa-undo-alt"
                            :disabled="predefined_message_disabled"
                         />
                    </fieldset>
                </div>

                <div class="submit-desktop">
                    <ActionButton
                        :loading=content_state.saving
                        @click='save()'
                        class="main-action"
                        icon="fas fa-save"
                        text="global.actions.save"
                        :gtm="{
                            module : 'out_of_office_settings',
                            feature: 'out_of_office_form',
                            block  : `bottom_actions`,
                            action : 'submit'
                        }"
                    />
                </div>
            </form>
        </template>
    </SectionViewLayout>
</template>

<script setup>
  import { onBeforeMount, ref }         from 'vue';
  import { reactive, computed }         from 'vue';
  import { useRouter }                  from 'vue-router';
  import ActionButton                   from '@/vue/Elements/Buttons/ActionButton.vue';
  import SectionViewLayout              from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import OutOfOfficeOptionsController   from '@/js/Settings/OutOfOffice/OutOfOfficeOptionsController.js';
  import PropertiesValidation           from '@/js/Shared/Validation/PropertiesValidation';
  import ContentState                   from '@/js/Shared/State/ContentState';
  import Language                       from '@/js/Shared/Language/Language.js';
  import InputTextArea                  from '@/vue/Elements/Inputs/InputTextArea.vue';
  import InputRadio                     from '@/vue/Elements/Inputs/InputRadio.vue';
  import InputDateRange                 from '@/vue/Elements/Inputs/InputDateRange.vue';

  const route                       = useRouter();
  const out_of_office_controller    = reactive(new OutOfOfficeOptionsController());
  const validation_checked          = ref(false);
  const content_state               = reactive(new ContentState());
  const properties_validation       = reactive(new PropertiesValidation({
    'date_start' : { required: true },
    'message'    : { required: true }
  }))



  const predefined_message_disabled = computed(() =>  {
    return out_of_office_controller.options.message === out_of_office_controller.predefined_message
  })

  content_state.onErrorRetry(async () => {
    fetchOptions();
    onChangeDate()
  })

  onBeforeMount(async () => {
    fetchOptions();
    onChangeDate()
  })

  const fetchOptions = async () => {
    content_state.setLoading();
    content_state.setLoadedState(
      await out_of_office_controller.fetchOptions()
    );
  }

  const onChangeDate = () => {
    out_of_office_controller.setPredefinedTagByDate();

    if (out_of_office_controller.options.enabled === false
        || predefined_message_disabled.value === true) {
        resetMessage();
    }

    validateFields()
  }

  const resetMessage = () => {
    out_of_office_controller.options.message = out_of_office_controller.predefined_message
  }

  const validateFields = () => {
    if(validation_checked.value) {
        properties_validation.validateObject(out_of_office_controller.options)
    }
  }

  const save = async () => {
    validation_checked.value = true
    if (properties_validation.validateObject(out_of_office_controller.options) === false
        && out_of_office_controller.options.enabled ) {
        return
    }

    content_state.setSaving(true);
    let response         = await out_of_office_controller.saveOptions()
    content_state.setSaving(false);

    if (response) {
      close()
    }
  }

  const close = () => {
    route.push('/settings/');
  }
</script>